// src/utils/rem.js
(function (win) {
  // 基准大小（推荐与设计稿宽度比例相关）
  const baseSize = 16; // 1rem = 16px（与postcss配置保持一致）

  // 设置rem函数
  function setRem() {
    // 设计稿默认宽度（根据实际设计稿尺寸调整）
    const designWidth = 1920;

    // 当前窗口宽度
    const clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;

    // 计算缩放比例（限制最大/最小比例可选）
    const scale = Math.min(Math.max(clientWidth / designWidth, 0.5), 2); // 限制在0.5-2倍之间

    // 设置根字体大小
    document.documentElement.style.fontSize = baseSize * scale + "px";
  }

  // 初始化执行
  setRem();

  // 监听窗口变化
  win.addEventListener("resize", setRem);
  win.addEventListener("pageshow", function (e) {
    if (e.persisted) setRem();
  });
})(window);
